/**
 * Mapeamento de códigos de pendência de firma para campos do formulário.
 * Centraliza a lógica de filtragem e mapeamento usada na tela de confirmação de firma.
 */

export const CODIGOS_FILTRADOS = ['BIOMETRIA', 'IMAGEM'];

export const CODIGO_PARA_CAMPOS = {
  NOME: ['nome'],
  ENDERECO: ['logradouro', 'numero', 'bairro', 'cidade', 'estado'],
  PROFISSAO: ['profissao'],
  NACIONALIDADE: ['nacionalidade'],
  ESTADO_CIVIL: ['estadoCivil'],
  FILIACAO: ['nomePai', 'nomeMae'],
  TELEFONE: ['telefone', 'celular'],
  EMAIL: ['email'],
  CPF: ['documento', 'documentoDesconhecido'],
  DOCUMENTO_IDENTIFICACAO: ['rg', 'cnh', 'oab', 'cip', 'passaporte', 'outrosDocumentos'],
  ORGAO_EMISSOR: ['orgaoEmissor'],
  DATA_EMISSAO: ['dataEmissaoRg'],
  DEFICIENTE_VISUAL: ['deficienteVisual'],
  SEMIALFABETIZADO: ['semialfabetizado'],
  MENOR: ['menor'],
  INCAPAZ: ['incapaz'],
};

/**
 * Filtra bloqueios removendo códigos não editáveis (BIOMETRIA, IMAGEM).
 * @param {Array<{codigo: string, mensagem: string}>|undefined|null} bloqueios
 * @returns {{ editaveis: Array, somenteNaoEditaveis: boolean }}
 */
export const filtrarPendenciasEditaveis = (bloqueios) => {
  if (!Array.isArray(bloqueios) || bloqueios.length === 0) {
    return { editaveis: [], somenteNaoEditaveis: false };
  }

  const editaveis = bloqueios.filter(
    (item) => !CODIGOS_FILTRADOS.includes(item.codigo),
  );

  return {
    editaveis,
    somenteNaoEditaveis: editaveis.length === 0,
  };
};

/**
 * Mapeia um array de pendências editáveis a uma lista plana de nomes de campo,
 * sem duplicatas.
 * @param {Array<{codigo: string}>} editaveis
 * @returns {string[]}
 */
export const mapearCamposPendentes = (editaveis) => {
  if (!Array.isArray(editaveis) || editaveis.length === 0) {
    return [];
  }

  const campos = editaveis.flatMap(
    (item) => CODIGO_PARA_CAMPOS[item.codigo] || [],
  );

  return [...new Set(campos)];
};

export default {
  CODIGOS_FILTRADOS,
  CODIGO_PARA_CAMPOS,
  filtrarPendenciasEditaveis,
  mapearCamposPendentes,
};
